import axios from 'axios';

import type { Requestor } from '@openid/appauth';
import type { XhrSettings } from 'ionic-appauth/lib/cordova';

export class CapacitorRequestorAxios implements Requestor {
    // eslint-disable-next-line class-methods-use-this -- Extending class method, and since javascript don't support accessing static methods from the instance, it might break to do so if the superclass calls this function.
    public async xhr<T>(settings: XhrSettings): Promise<T> {
        const response = await axios({
            url: settings.url,
            method: settings.method || 'GET',
            data: settings.data,
            headers: settings.headers,
        });
        return response.data as T;
    }
}
